<template>
  <div id="spore-analyse" style="overflow:hidden;">
    <div class="sporeAnalyse-data">
      <div class="sporeAnalyse-data-head">
        <div class="sporeAnalyse-head-title">
          <span class="sporeAnalyse-head-title-container">孢子图片分析</span>
        </div>

        <div class="sporeAnalyse-head-select">
          <div class="sporeAnalyse-select-device">
            <el-select @change="sporeDeviceChange($event)" v-model="defaultSporeDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in sporeDeviceList"></el-option>
            </el-select>
          </div>

          <div class="sporeAnalyse-select-time">
            <el-date-picker @change="sporeSelectTime" v-model="defaultSporeTime" unlink-panels type="datetimerange" :picker-options="sporePickerOptions" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="sporeAnalyse-select-btn" >
            <el-button type="primary" @click="sporeQueryData()">查询</el-button>
          </div>
        </div>
      </div>

      <div class="sporeAnalyse-data-content" style="overflow: auto;">
        <div v-for="(row,index) in sliceList(sporePicList.slice((sporeCurrentPage-1)*6,sporeCurrentPage*6), 3)" :key="index" style=" width: 100%;height: 40%;">
          <div class="sporeAnalyse-data-body">
            <div class="sporeAnalyse-data-body-container"  v-for="(item,i) in row">
              <div class="sporeAnalyse-container-left">
                <img :src="item.imagesUrl" @click="openModal(item.imagesUrl)" class="sporeAnalyse-container-left-img" referrerpolicy="no-referrer">
              </div>
              <div class="sporeAnalyse-container-right">
                <div class="sporeAnalyse-container-right-recordId">记录表id: {{item.recordId}}</div>
                <div class="sporeAnalyse-container-right-deviceAdr">设备地址：{{item.deviceAddr}}</div>
                <div class="sporeAnalyse-container-right-createTime">采样时间：<br/>{{item.createTime}}</div>
                <div class="sporeAnalyse-container-right-verifyTime" style="margin-top: 8%">分析时间：<br/>{{item.verifyTime}}</div>
                <div class="sporeAnalyse-container-right-analyst" style="margin-top: 8%">分析员：{{item.analyst}}</div>
                <div class="sporeAnalyse-container-right-remarks" style="">备注：{{item.remark}}</div>
              </div>
            </div>
          </div>

          <div v-if="showModal" class="spore-modal" @click="closeModal">
            <div class="spore-modal-content">
              <img :src="selectedImage" alt="放大的图片" class="spore-enlarged-image" />
            </div>
          </div>
        </div>
        <el-pagination @current-change="sporeCurrentChange" :current-page="sporeCurrentPage" style="text-align: center; margin-top: 1.5%"
                       :page-size="6" layout="total, prev, pager, next, jumper" :total="sporePicList.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {sporeDataAndAIByDO} from "../../until/api/SporePest";
  export default {
    name: 'SporeAnalyseData',
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },
    data() {
      return {
        sporeDeviceList: [],
        defaultSporeDevice: '',
        defaultSporeTime: [ moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        sporePickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        sporePicList: [],
        sporeCurrentPage: 1,
        showModal: false, // 控制模态框的显示
        selectedImage: null, // 存储点击的图片URL
      }
    },

    mounted() {
      this.sporeHistoryList(); //获取孢子设备列表
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //初期化开始时间
      this.endTime = moment().format("YYYY-MM-DD HH:mm:ss");//初期化结束时间
    },

    methods: {
      sporeHistoryList() {
        let that = this;
        this.$SporePestCommon.getSpDeviceList(function (deviceList) { //获取所有孢子虫情设备
          for(let i = 0; i < deviceList.data.length; i++) {
            if(deviceList.data[i].deviceType == 'spore') {//筛选出孢子设备
              let sporeJson = {};
              sporeJson.deviceAddr = deviceList.data[i].deviceAddr;
              sporeJson.deviceName = deviceList.data[i].deviceName;
              that.sporeDeviceList.push(sporeJson);
            }
          }
          if(that.sporeDeviceList.length > 0) {
            that.defaultSporeDevice = that.sporeDeviceList[0].deviceAddr; //默认孢子设备
            that.sporeAnalyseData();//获取图片分析数据
          }
        })
      },

      sporeDeviceChange(event) {
        this.defaultSporeDevice = event;
        this.sporePicList = []; //清空数据列表
      },

      sporeSelectTime(val) {
        if (val === null) {//清空日期
          this.defaultSporeTime = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]; //默认时间
          this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().format("YYYY-MM-DD HH:mm:ss");//默认结束时间
        } else {//非清空数据
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //结束时间
        }
      },

      sporeQueryData() {
        if(this.defaultSporeDevice != '') {
          this.sporeAnalyseData(); //获取图片分析数据
        }
      },

      sporeAnalyseData() {
        this.sporeCurrentPage = 1;
        this.sporePicList = [];
        sporeDataAndAIByDO(this.beginTime, this.endTime, this.defaultSporeDevice).then(response => {
          if( response.data.code != 2000 && response.data.data.rows.length > 0) {
            for(let i = 0; i < response.data.data.rows.length; i++) {
              let sporeJson = {};
              sporeJson.recordId = response.data.data.rows[i].recordId; //记录表id
              sporeJson.deviceAddr = response.data.data.rows[i].deviceAddr; //设备地址
              sporeJson.analyst = response.data.data.rows[i].analyst == null ? '-' : response.data.data.rows[i].analyst; //分析员
              sporeJson.createTime = response.data.data.rows[i].createTime; //创建时间
              sporeJson.verifyTime = response.data.data.rows[i].verifyTime == '2000-01-01 08:00:00' ? '-' : response.data.data.rows[i].verifyTime; //分析时间
              sporeJson.remark = response.data.data.rows[i].remark == null ? '-' : response.data.data.rows[i].remark; //备注
              sporeJson.imagesUrl =  response.data.data.rows[i].imagesUrl; //图片地址
              this.sporePicList.push(sporeJson);
            }
          } else {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '所选的时间段内未查询出数据'
            })
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      sporeCurrentChange(currentPage) {
        this.sporeCurrentPage = currentPage;
      },

      openModal(targetUrl) {
        const image = new Image();
        image.src = targetUrl;
        image.onload = () => {
          this.selectedImage = targetUrl; // targetUrl 加载成功
        };

        this.showModal = true; // 显示模态框
      },

      closeModal() {
        this.showModal = false; // 关闭模态框
        this.selectedImage = null; // 清除图片URL
      },
    }
  }
</script>

<style lang="less">
  @import "../less/SporeAnalyseData";
</style>

<style>
  .sporeAnalyse-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/SporeAnalyseData.vue